import React, { useEffect, useRef } from 'react';
import { Component } from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { createSidebar } from '../../redux/actions/general/sidebar';
import { setPlusActions } from '../../redux/actions/general/plus';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import {
  __,
  dateFrom,
  dateTimeFrom,
  getActiveStage,
  getURLParam,
  redirect,
} from '../../core/utils';
import Table from '../../components/Table';
import { getTeamsPermissions } from '../../redux/actions/table/teams';
import Tooltip from '../../components/Tooltip';
import { withRouter } from 'react-router';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import Avatar from '../../components/Avatar';
import {
  deletePlanSettingTemplate,
  listPlanSettingTemplates,
  readPlanSettingTemplates,
} from '../../redux/actions/table/plan_setting_templates';
import Localization from '../../helpers/Localization';
import { subscribe } from 'react-contextual';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import { setNotification } from '../../redux/actions/general/notification';
import PlanSettingTemplateFlyout from './PlanSettingTemplateFlyout';

const PlanSettingTemplates = ({ match, actions, table }) => {
  const prevClickedRowRef = useRef();

  useEffect(() => {
    const prevClickedRow = prevClickedRowRef.current;

    if (table.clicked_row && table.clicked_row !== prevClickedRow) {
      if (!prevClickedRow) {
        actions.setTableParams({
          flyout: undefined,
        });
      }

      readPlanSettingTemplates(table.clicked_row);
    }

    prevClickedRowRef.current = table.clicked_row;
  }, [table.clicked_row]);

  useEffect(() => {
    getTeamsPermissions(match.params.stage).then(({ response }) => {
      const team_roles = _.get(response.data, 'teams', {});

      enableProjectsDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plan_setting_templates')
      );
      enableStagesDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plan_setting_templates')
      );

      createSidebar({
        title: __('submenu.title.plans'),
        items: [
          {
            title: __('submenu.title.current-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/current',
          },
          {
            title: __('submenu.title.working-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/working',
          },
          {
            title: __('submenu.title.uploads'),
            active: true,
            items: [
              {
                title: __('submenu.title.uploads-list'),
                link: () => '/stages/' + getActiveStage() + '/plans/uploads',
              },
              {
                title: __('submenu.title.ocr-templates'),
                link: () => '/stages/' + getActiveStage() + '/ocr_templates',
              },
              {
                title: __('submenu.title.plan_setting_templates'),
                link: () =>
                  '/stages/' + getActiveStage() + '/plan_setting_templates',
                active: true,
              },
            ],
          },
          {
            title: __('submenu.title.deliveries'),
            link: () => '/stages/' + getActiveStage() + '/deliveries',
          },
          {
            title: __('submenu.title.approvals'),
            link: () => '/stages/' + getActiveStage() + '/approvals',
          },
        ],
      });

      !_.isEmpty(team_roles.editor) &&
        setPlusActions([
          {
            title: __('button.create-new-template'),
            onClick: () =>
              actions.setTableParams({
                add_plan_setting_template_wizard: true,
              }),
          },
        ]);
    });
  }, []);

  const columns = [
    {
      key: 'name',
      name: __('plan_setting_templates.field.name'),
      required: true,
      sortable: false,
    },
    {
      key: 'created_at',
      name: __('plan_setting_templates.field.created-at'),
      value: (created_at) => (
        <Tooltip text={dateTimeFrom(created_at)}>
          {dateFrom(created_at)}
        </Tooltip>
      ),
      width: 80,
      sortable: false,
    },
    {
      key: 'created_by',
      name: __('plan_setting_templates.field.created-by'),
      value: (user) => (
        <Avatar
          avatar_url={user.avatar_url}
          name={user.fullname}
          active={user.active}
        />
      ),
      width: 50,
      sortable: false,
    },
  ];

  const singleActions = (plan_setting_template_id) => {
    return [
      <Tooltip
        text={__('plan_setting_templates.tooltip.delete-plan-settings')}
        key={_.uniqueId()}
      >
        <DeleteIcon
          onClick={(e) => {
            e.stopPropagation();

            showAlertbox({
              color: 'red',
              title: __('general.alert.are-you-sure'),
              description: __(
                'plan-settings-templates.alert.delete-confirmation'
              ),
              buttons: [
                {
                  color: 'lightGray',
                  text: __('general.alert.no-close'),
                  onClick: 'close',
                },
                {
                  color: 'gray',
                  text: __('general.alert.yes-delete'),
                  onClick: () => {
                    deletePlanSettingTemplate([plan_setting_template_id]).then(
                      () => {
                        hideAlertbox();

                        setNotification(
                          __('plan-settings-templates.alert.deleted')
                        );
                        listPlanSettingTemplates(match.params.stage);

                        actions.setTableParams({
                          actioned_row: undefined,
                        });
                      }
                    );
                  },
                },
              ],
            });
          }}
        />
      </Tooltip>,
    ];
  };

  // const groupActions = (ocr_template_ids) => [
  //   <Tooltip
  //     text={__('plan-settings-template.tooltip.delete-selected-template')}
  //     key={_.uniqueId()}
  //   >
  //     {/* <DeleteIcon
  //       onClick={(e) => {
  //         e.stopPropagation();

  //         showAlertbox({
  //           color: 'red',
  //           title: __('general.alert.are-you-sure'),
  //           description: __(
  //             'ocr-templates.alert.multiple-delete-confirmation'
  //           ),
  //           buttons: [
  //             {
  //               color: 'lightGray',
  //               text: __('general.alert.no-close'),
  //               onClick: 'close',
  //             },
  //             {
  //               color: 'gray',
  //               text: __('general.alert.yes-delete'),
  //               onClick: () => {
  //                 deleteOCRTemplates(ocr_template_ids).then(() => {
  //                   hideAlertbox();

  //                   setNotification(
  //                     __('ocr-templates.alert.multiple-deleted')
  //                   );
  //                   listOCRTemplates(this.props.match.params.stage);

  //                   setTableParams('ocr_templates', {
  //                     selected_rows: [],
  //                   });
  //                 });
  //               },
  //             },
  //           ],
  //         });
  //       }}
  //     /> */}
  //   </Tooltip>,
  // ];

  const preview = (
    <PlanSettingTemplateFlyout
      data={table.flyout}
      readAction={(plan_setting_template_id) => {
        return new Promise(() => {
          readPlanSettingTemplates(
            getURLParam('id') || plan_setting_template_id
          );
        });
      }}
    />
  );

  return (
    <Table
      listAction={() => listPlanSettingTemplates(match.params.stage)}
      name='plan_setting_templates'
      title={__('submenu.title.plan_setting_templates')}
      columns={columns}
      singleActions={singleActions}
      //groupActions={groupActions}
      preview={table.flyout ? preview : []}
      onLoad={() => listActiveModules()}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    table: state.table['plan_setting_templates'],
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.plan_setting_templates/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(subscribe(Localization, 'localization')(PlanSettingTemplates))
);
